'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosGearOutline = function IoIosGearOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.1 12.5c2 0 3.9 0.8 5.3 2.2s2.2 3.3 2.2 5.3-0.8 3.9-2.2 5.3-3.3 2.2-5.3 2.2-3.9-0.8-5.3-2.2-2.2-3.3-2.2-5.3 0.8-3.9 2.2-5.3 3.2-2.2 5.3-2.2z m0 13.8c3.4 0 6.2-2.9 6.2-6.3s-2.8-6.2-6.2-6.2-6.3 2.8-6.3 6.2 2.8 6.3 6.3 6.3z m-4.3-19.8c-0.8 0.2-1.6 0.5-2.4 0.9 0.2 0.6 0.1 1.3 0 1.9-0.1 1-0.6 2-1.4 2.7-0.9 1-2.2 1.5-3.6 1.5-0.3 0-0.7 0-1-0.1-0.4 0.8-0.7 1.6-0.9 2.4 0.5 0.3 0.9 0.8 1.3 1.3 0.6 0.9 1 1.9 1 2.9s-0.4 2-1 2.9c-0.4 0.5-0.8 1-1.3 1.3 0.2 0.8 0.5 1.6 0.9 2.4 0.3-0.1 0.7-0.1 1-0.1 1.4 0 2.7 0.5 3.6 1.5 0.8 0.8 1.3 1.7 1.4 2.7 0.1 0.6 0.2 1.3 0 1.9 0.8 0.4 1.6 0.7 2.4 0.9 0.3-0.5 0.8-0.9 1.3-1.3 0.9-0.6 1.9-0.9 2.9-0.9s2 0.3 2.9 0.9c0.5 0.4 1 0.8 1.3 1.3 0.8-0.2 1.6-0.5 2.4-0.9-0.2-0.6-0.1-1.3 0-1.9 0.1-1 0.6-1.9 1.4-2.7 0.9-1 2.2-1.5 3.6-1.5 0.3 0 0.7 0 1 0.1 0.4-0.8 0.7-1.6 0.9-2.4-0.5-0.3-0.9-0.8-1.3-1.3-0.6-0.9-0.9-1.9-0.9-2.9s0.3-2 0.9-2.9c0.4-0.5 0.8-1 1.3-1.3-0.2-0.8-0.5-1.6-0.9-2.4-0.3 0.1-0.7 0.1-1 0.1-1.4 0-2.7-0.5-3.6-1.5-0.8-0.7-1.3-1.7-1.4-2.7-0.1-0.6-0.2-1.3 0-1.9-0.8-0.4-1.6-0.7-2.4-0.9-0.3 0.5-0.8 0.9-1.3 1.3-0.9 0.6-1.9 1-2.9 1s-2-0.4-2.9-1c-0.5-0.4-1-0.8-1.3-1.3z m7.8-1.5c1.6 0.4 3.1 1 4.4 1.9-0.6 1.4-0.3 3.1 0.8 4.3 0.8 0.8 1.7 1.1 2.8 1.1 0.5 0 1.1-0.1 1.5-0.3 0.9 1.3 1.5 2.8 1.9 4.4-1.5 0.6-2.5 2-2.5 3.6s1.1 3 2.5 3.6c-0.4 1.6-1 3.1-1.9 4.4-0.4-0.2-1-0.3-1.5-0.3-1.1 0-2 0.3-2.8 1.1-1.1 1.2-1.4 2.9-0.8 4.3-1.3 0.9-2.8 1.5-4.4 1.9-0.6-1.4-2-2.5-3.6-2.5s-3 1.1-3.6 2.5c-1.6-0.4-3.1-1-4.4-1.9 0.6-1.4 0.3-3.1-0.8-4.3-0.8-0.8-1.7-1.1-2.8-1.1-0.5 0-1.1 0.1-1.5 0.3-0.9-1.3-1.5-2.8-1.9-4.4 1.4-0.6 2.5-2 2.5-3.6s-1-3-2.5-3.6c0.4-1.6 1-3.1 1.9-4.4 0.4 0.2 1 0.3 1.5 0.3 1.1 0 2-0.3 2.8-1.1 1.1-1.2 1.4-2.9 0.8-4.3 1.3-0.9 2.8-1.5 4.4-1.9 0.6 1.5 2 2.5 3.6 2.5s3-1 3.6-2.5z' })
        )
    );
};

exports.default = IoIosGearOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-gear-outline.js
// module id = 2654
// module chunks = 168707334958949